(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.store-demo-video').forEach(function(video) {
    var figure = video.closest('figure'), button = figure.querySelector('.store-video-toggle');
    var visible = false, userPaused = false, loaded = false;
    video.autoplay = false;
    function load() {
      if (loaded) return;
      video.querySelectorAll('source[data-src]').forEach(function(source) { source.src = source.dataset.src; });
      loaded = true; video.load();
    }
    function label() { button.textContent = video.paused ? 'Play video' : 'Pause video'; button.setAttribute('aria-label', (video.paused ? 'Play ' : 'Pause ') + video.id.replace('demo-', '').toUpperCase() + ' video'); }
    function play() { load(); var promise = video.play(); if (promise) promise.catch(label); }
    function update() {
      if (visible) load();
      if (visible && !document.hidden && !reduced.matches && !userPaused) play();
      else if (!visible || document.hidden || reduced.matches) video.pause();
    }
    button.addEventListener('click', function() { if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); } });
    video.addEventListener('play', function() { userPaused = false; label(); });
    video.addEventListener('pause', function() { if (visible && !document.hidden && !reduced.matches) userPaused = true; label(); });
    video.addEventListener('error', function() { figure.querySelector('.store-video-error').hidden = false; button.hidden = true; });
    document.addEventListener('visibilitychange', update);
    reduced.addEventListener('change', update);
    if ('IntersectionObserver' in window) new IntersectionObserver(function(entries) { visible = entries[0].isIntersecting; update(); }, {threshold:0.3}).observe(video);
    else { visible = true; update(); }
    label();
  });
})();
